module.exports = __webpack_public_path__ + "static/img/anxunu07.ff7c487c.png";